"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatedColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
function useDatedColumns() {
    const intl = react_intl_1.useIntl();
    const columnCreated = react_1.useMemo(() => ({
        datakey: 'created',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_CREATED',
            defaultMessage: 'Vytvoření',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const columnUpdated = react_1.useMemo(() => ({
        datakey: 'updated',
        name: intl.formatMessage({
            id: 'EAS_EVIDENCE_COLUMN_UPDATED',
            defaultMessage: 'Poslední úprava',
        }),
        width: 150,
        CellComponent: table_cells_1.TableCells.DateTimeCell,
        sortable: true,
        filterable: true,
    }), [intl]);
    const datedColumns = react_1.useMemo(() => [columnCreated, columnUpdated], [columnCreated, columnUpdated]);
    return {
        columnCreated,
        columnUpdated,
        datedColumns,
    };
}
exports.useDatedColumns = useDatedColumns;
//# sourceMappingURL=dated-columns.js.map